import { useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Form, Input, Submit } from "../Form";
import { Actions } from "../Modal";
import { resetPassword } from "../../features/accounts/accountSlice";

const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const handleShowPassword = () => setShowPassword(!showPassword);
    const [showConfirm, setShowConfirm] = useState(false);
    const handleShowConfirm = () => setShowConfirm(!showConfirm);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const handleShowNewPassword = () => setShowNewPassword(!showNewPassword);
    const dispatch = useDispatch()
    const methods = useForm({ shouldUnregister: true })

    const onSubmit = values => {
        if(values.password === values.newPassword) return methods.setError('newPassword', { type: 'error', message: 'La nueva contraseña deben ser diferente a la anterior'})
        else if(values.newPassword !== values.confirm) return methods.setError('confirm', { type: 'error', message: 'Las contraseñas deben ser iguales'})
        else resetPassword(values, dispatch, methods.setError)
    }
    return(
        <Actions title={'Cambiar Contraseña'}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input type={ showPassword ? 'text' : 'password' } name={'password'} label="Contraseña actual" min={8} max={20} handleShowPassword={handleShowPassword} />
                    <Input type={ showNewPassword ? 'text' : 'password' } name={'newPassword'} label="Nueva contraseña" min={8} max={20} handleShowPassword={handleShowNewPassword} />
                    <Input type={ showConfirm ? 'text' : 'password' } name={'confirm'} label="Escribe nuevamente la nueva contraseña" min={8} max={20} handleShowPassword={handleShowConfirm} />
                    <Submit title={'Guardar Cambios' } />
                </Grid>
            </Form>
        </Actions>
    )
}

export default ResetPassword;